export default __webpack_public_path__ + "img/f7f84f9c2620b01e6cbe562c09d2200e.svg";